import { Component, createSignal, For, Show } from "solid-js"
import { SelectionMode } from "../../lib/core/engine/SelectionMode/SelectionMode.enum"
import selectionModeMetaList from "../../lib/core/engine/SelectionMode/selectionModeMetaList"
import EmSmallTextMuted from "../Util/EmSmallTextMuted"

interface Props {
  value: SelectionMode
  onChange: (value: SelectionMode) => void
}

const SelectSelectionMode: Component<Props> = (props) => {
  const selectedMode = () => {
    return selectionModeMetaList.find(mode => mode.value === props.value) || selectionModeMetaList[0]
  }
  const [isDropDownOpen, setIsDropDownOpen] = createSignal<boolean>(false)

  return (
    <div class="dropdown">
      <button 
        class="btn btn-outline-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between" 
        type="button" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
        onClick={() => { setIsDropDownOpen(!isDropDownOpen()) }}
      >
        <span class="d-flex align-items-center">
          <Show when={selectedMode()} keyed children={(mode) => {
            const { icon: Icon, label } = mode
            return <>
              <Icon class="me-2" />
              {label}
            </>
          }} fallback={EmSmallTextMuted('No Selection Mode')} />
        </span>
      </button>
      <ul classList={{ 'dropdown-menu': true, show: isDropDownOpen(), 'w-100': true }}>
        <For each={selectionModeMetaList}>
          {(mode) => {
            const Icon = mode.icon
            return (
              <li>
                <button 
                  class="dropdown-item d-flex align-items-center" 
                  type="button"
                  onClick={() => {
                    props.onChange(mode.value)
                    setIsDropDownOpen(false)
                  }}
                >
                  <Icon class="me-2" />
                  {mode.label}
                </button>
              </li>
            )
          }}
        </For>
      </ul>
    </div>
  )
}

export default SelectSelectionMode
